import * as React from 'react'
import { OpportunityCards } from './OpportunityCards'
import { OppCardsProviderProps } from '../typings'
import { useGetData } from './useGetData'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { setOpportunityPage } from '@user/store/opportunity'

export function OpportunityCardsProvider(props: OppCardsProviderProps) {
  const { loading, ...rest } = props

  const dispatch = useAppDispatch()
  const data = useGetData(loading)

  const onChangePage = React.useCallback(
    (_e: React.ChangeEvent<unknown>, page: number) => {
      sessionStorage.setItem('pageNumber', page?.toString())
      dispatch(setOpportunityPage(page))
      document
        .getElementById('topScrollIndicator')
        ?.scrollIntoView({ block: 'end', behavior: 'smooth' })
    },
    [dispatch],
  )

  return (
    <>
      <span id="topScrollIndicator"></span>
      <OpportunityCards {...rest} {...data} onChangePage={onChangePage} />
    </>
  )
}
